import { useCallback, useMemo } from 'react';
import type { SelectOption } from '../simple-select';
import { useSelectOptions } from './use-select-options';

interface UseMultiSelectProps {
  options: SelectOption[];
  value: string[];
  onChange: (value: string[]) => void;
}

export function useMultiSelect({ options, value, onChange }: UseMultiSelectProps) {
  const { items, labelToValueMap, getLabels, getValues } = useSelectOptions(options);

  const selectedLabels = useMemo(() => getLabels(value), [value, getLabels]);

  const handleValueChange = useCallback(
    (selectedLabels: string[] | null) => {
      if (!selectedLabels) {
        onChange([]);
        return;
      }
      const selectedValues = getValues(selectedLabels);
      onChange(selectedValues);
    },
    [getValues, onChange]
  );

  const getLabelKey = useCallback((label: string) => labelToValueMap.get(label) || label, [labelToValueMap]);

  return {
    items,
    selectedLabels,
    handleValueChange,
    getLabelKey
  };
}
